/*
 * @Description:
 * @Author: fal
 * @Date: 2024-11-25 15:30:20
 * @FilePath: \xhlz_pc\src\project\router\index.js
 * @LastEditTime: 2025-08-25 15:57:27
 */
import project from './modules/project.js';
import person from './modules/person.js';
import { frontRoutes } from './modules/front.js';
import { supplierRoutes } from './modules/supplier.js';
import { doerRoutes } from './modules/doer.js';

const newroutes = [
  ...project,
  ...person,
  ...frontRoutes,
  ...supplierRoutes,
  ...doerRoutes,
  // 跳转loading
  {
    path: '/jump',
    name: 'jump',
    component: () => import('../components/jump.vue'),
  },
];

export default newroutes;
